package com.bikompanion.ui.watch

import com.bikompanion.domain.StationWatch

sealed interface StationWatchEvent {
    data class Started(
        val watch: StationWatch,
    ) : StationWatchEvent

    data class Found(
        val watches: List<StationWatch>,
    ) : StationWatchEvent

    data class Expired(
        val watches: List<StationWatch>,
        val hasActiveWatches: Boolean,
    ) : StationWatchEvent

    data object Stopped : StationWatchEvent
}
